/* import external modules */
import styled from 'styled-components'

export const Button = styled.button`
  align-items: center;
  background: none;
  border: ${(props) => (props.selectedTab === "ET CONDOLENCIAS" ? '1px solid #0066A5' : 'none')};
  border-radius: ${(props) => (props.selectedTab === "ET CONDOLENCIAS" ? '4px' : 'none')};
  color: ${({ theme }) => theme.colors.secondary};
  cursor: pointer;
  display: flex;
  font: 14px/20px 'DMSans-Regular';
  height: 24px;
  justify-content: ${(props) => (props.selectedTab === "ET CONDOLENCIAS" ? "center" : "flex-end")};
  margin-right: 10px;
  margin-top: 12px;
  padding: ${(props) => (props.selectedTab === "ET CONDOLENCIAS" ? "10%" : 0)};
  width: ${(props) => (props.selectedTab === "ET CONDOLENCIAS" ? "155px" : "auto")};
  @media (max-width:1024px) {
    width: ${(props) => (props.selectedTab === "ET CONDOLENCIAS" ? "100%" : "auto")};
    padding: ${(props) => (props.selectedTab === "ET CONDOLENCIAS" ? "5%" : 0)};
    justify-content: ${(props) => (props.selectedTab === "ET CONDOLENCIAS" ? "center" : "start")};

  }

  svg {
    margin-right: 10px;
    flex-shrink: 0;
  }
  &:hover {
    text-decoration: underline;
  }
  @media (max-width: 1168px) {
    margin: 12px 0 12px 10px;
  }
  @media (max-width: 1024px) {
    margin-left: 0;
    &:hover {
      text-decoration: underline;
    }
  }
`
